import React, { FC, memo, useEffect, useRef, useState } from 'react';
import TagButton from '@/components/TagButton';
import styles from './ScrollTag.module.scss';
import { useLanguage } from '@/hooks/use-language';
import { ScrollTagProps } from './ScrollTag.types';

const ScrollTag = memo((props: ScrollTagProps) => {
  const language = useLanguage();

  const { hotTopicList } = props;

  const getTargetUrl = (item: any) => {
    let hotTopicUrl = '';
    const encodeParam = encodeURIComponent(item?.url);
    if (item && item._content_type_uid === 'blog_product_tags_block') {
      hotTopicUrl = `/${language !== 'en' ? 'zh' : 'en'}/blog/product/?t=${encodeParam}`;
    } else if (item && item._content_type_uid === 'blog_topic_block') {
      const encodeParam = encodeURIComponent(item?.url);
      hotTopicUrl = `/${language !== 'en' ? 'zh' : 'en'}/blog/topic/?t=${encodeParam}`;
    }
    return hotTopicUrl;
  };
  return (
    <div className={styles.scroll_tag_container}>
      <div className={styles.scroll_tag_title}>
        {language !== 'en' ? '🔥 Top 10 熱門話題' : '🔥 Top 10 Hot Tags'}
      </div>
      <div className={styles.scroll_tag_content_desktop}>
        <div className={styles.scroll_tag_left_mask}></div>
        <div className={styles.scroll_tag_rowup_1}>
          {hotTopicList.length > 0 &&
            hotTopicList.map((item: any, index: number) => (
              <div className={styles.scroll_tag_item} key={index}>
                <span className={styles.scroll_tag_item_number}>{index + 1}</span>
                <TagButton title={item.title} targetUrl={getTargetUrl(item)} emoji={item?.emoji} />
              </div>
            ))}
        </div>
        <div className={styles.scroll_tag_rowup_2} style={{ marginLeft: 16 }}>
          {hotTopicList.length > 0 &&
            hotTopicList.map((item: any, index: number) => (
              <div className={styles.scroll_tag_item} key={index}>
                <span className={styles.scroll_tag_item_number}>{index + 1}</span>
                <TagButton title={item.title} targetUrl={getTargetUrl(item)} emoji={item?.emoji} />
              </div>
            ))}
        </div>
        <div className={styles.scroll_tag_right_mask}></div>
      </div>
      <div className={styles.scroll_tag_content_mobile}>
        <div className={styles.scroll_tag_first_line}>
          <div className={styles.scroll_tag_first_line_scroll_1}>
            {hotTopicList.length > 0 &&
              hotTopicList
                .slice(0, Math.ceil(hotTopicList.length / 2))
                .map((item: any, index: number) => (
                  <div className={styles.scroll_tag_item} key={index}>
                    <span className={styles.scroll_tag_item_number}>{index + 1}</span>
                    <TagButton
                      title={item.title}
                      targetUrl={getTargetUrl(item)}
                      emoji={item?.emoji}
                    />
                  </div>
                ))}
            {hotTopicList.length > 0 &&
              hotTopicList
                .slice(0, Math.ceil(hotTopicList.length / 2))
                .map((item: any, index: number) => (
                  <div className={styles.scroll_tag_item} key={index}>
                    <span className={styles.scroll_tag_item_number}>{index + 1}</span>
                    <TagButton
                      title={item.title}
                      targetUrl={getTargetUrl(item)}
                      emoji={item?.emoji}
                    />
                  </div>
                ))}
          </div>
          <div className={styles.scroll_tag_first_line_scroll_2} style={{ marginLeft: 8 }}>
            {hotTopicList.length > 0 &&
              hotTopicList
                .slice(0, Math.ceil(hotTopicList.length / 2))
                .map((item: any, index: number) => (
                  <div className={styles.scroll_tag_item} key={index}>
                    <span className={styles.scroll_tag_item_number}>{index + 1}</span>
                    <TagButton
                      title={item.title}
                      targetUrl={getTargetUrl(item)}
                      emoji={item?.emoji}
                    />
                  </div>
                ))}
            {hotTopicList.length > 0 &&
              hotTopicList
                .slice(0, Math.ceil(hotTopicList.length / 2))
                .map((item: any, index: number) => (
                  <div className={styles.scroll_tag_item} key={index}>
                    <span className={styles.scroll_tag_item_number}>{index + 1}</span>
                    <TagButton
                      title={item.title}
                      targetUrl={getTargetUrl(item)}
                      emoji={item?.emoji}
                    />
                  </div>
                ))}
          </div>
        </div>
        <div className={styles.scroll_tag_second_line}>
          <div className={styles.scroll_tag_second_line_scroll_1}>
            {hotTopicList.length > 0 &&
              hotTopicList
                .slice(Math.ceil(hotTopicList.length / 2))
                .map((item: any, index: number) => (
                  <div className={styles.scroll_tag_item} key={index}>
                    <span className={styles.scroll_tag_item_number}>
                      {Math.ceil(hotTopicList.length / 2) + index + 1}
                    </span>
                    <TagButton
                      title={item.title}
                      targetUrl={getTargetUrl(item)}
                      emoji={item?.emoji}
                    />
                  </div>
                ))}
            {hotTopicList.length > 0 &&
              hotTopicList
                .slice(Math.ceil(hotTopicList.length / 2))
                .map((item: any, index: number) => (
                  <div className={styles.scroll_tag_item} key={index}>
                    <span className={styles.scroll_tag_item_number}>
                      {Math.ceil(hotTopicList.length / 2) + index + 1}
                    </span>
                    <TagButton
                      title={item.title}
                      targetUrl={getTargetUrl(item)}
                      emoji={item?.emoji}
                    />
                  </div>
                ))}
          </div>
          <div className={styles.scroll_tag_second_line_scroll_2} style={{ marginLeft: 8 }}>
            {hotTopicList.length > 0 &&
              hotTopicList
                .slice(Math.ceil(hotTopicList.length / 2))
                .map((item: any, index: number) => (
                  <div className={styles.scroll_tag_item} key={index}>
                    <span className={styles.scroll_tag_item_number}>
                      {Math.ceil(hotTopicList.length / 2) + index + 1}
                    </span>
                    <TagButton
                      title={item.title}
                      targetUrl={getTargetUrl(item)}
                      emoji={item?.emoji}
                    />
                  </div>
                ))}
            {hotTopicList.length > 0 &&
              hotTopicList
                .slice(Math.ceil(hotTopicList.length / 2))
                .map((item: any, index: number) => (
                  <div className={styles.scroll_tag_item} key={index}>
                    <span className={styles.scroll_tag_item_number}>
                      {Math.ceil(hotTopicList.length / 2) + index + 1}
                    </span>
                    <TagButton
                      title={item.title}
                      targetUrl={getTargetUrl(item)}
                      emoji={item?.emoji}
                    />
                  </div>
                ))}
          </div>
        </div>
      </div>
    </div>
  );
});

export default ScrollTag;
